<script>
  import Index from '../index'
  export default Index
</script>